import { CommandMenuRecentItem } from './CommandMenu';

interface CommandMenuRecentItemsData {
    lastUpdated?: string;
    newItems: CommandMenuRecentItem[];
    savedItems: CommandMenuRecentItem[];
}
const getCommandMenuRecentItemsData = (userId: number = 0) => {
    const storageData = localStorage.getItem(`recent_items_${userId}`);
    const defaultData = {
        lastUpdated: undefined,
        newItems: [],
        savedItems: [],
    };

    if (storageData) {
        try {
            const data = JSON.parse(storageData);
            return {
                ...defaultData,
                lastUpdated: typeof data.lastUpdated === 'string' ? data.lastUpdated : defaultData.lastUpdated,
                newItems: Array.isArray(data.newItems) ? data.newItems : defaultData.newItems,
                savedItems: Array.isArray(data.savedItems) ? data.savedItems : defaultData.savedItems,
            };
        } catch (error) {
            return defaultData;
        }
    }

    return defaultData;
};

const saveCommandMenuRecentItemsData = (userId: number = 0, data: CommandMenuRecentItemsData) => {
    localStorage.setItem(`recent_items_${userId}`, JSON.stringify(data));
};

export const addCommandMenuNewRecentItem = (userId: number = 0, recentItem: CommandMenuRecentItem) => {
    const data = getCommandMenuRecentItemsData(userId);
    let newItemsData = [...data.newItems];

    const existingIndex = newItemsData.findIndex(
        (item: any) =>
            Number(item.item_id) === Number(recentItem.item_id) && item.object_type === recentItem.object_type,
    );

    if (existingIndex !== -1) {
        newItemsData.splice(existingIndex, 1);
    }

    newItemsData.unshift(recentItem);

    if (newItemsData.length > 20) {
        newItemsData = newItemsData.slice(0, 20);
    }
    saveCommandMenuRecentItemsData(userId, { ...data, newItems: newItemsData });
};

export const getCommandMenuNewRecentItems = (userId: number = 0) => {
    const data = getCommandMenuRecentItemsData(userId);
    return data.newItems;
};

export const onSaveCommandMenuNewRecentItems = (userId: number = 0) => {
    const data = getCommandMenuRecentItemsData(userId);
    const newSavedItemsList = getCommandMenuRecentItems(userId);
    saveCommandMenuRecentItemsData(userId, { ...data, newItems: [], savedItems: newSavedItemsList });
};

export const getCommandMenuRecentItems = (userId: number = 0) => {
    const data = getCommandMenuRecentItemsData(userId);

    const newRecentItems = [...data.newItems];
    const savedRecentItems = data.savedItems.filter((item: CommandMenuRecentItem) => {
        const isExistIndex = newRecentItems.findIndex((el: CommandMenuRecentItem) => {
            return el.item_id == item.item_id && el.object_type == item.object_type;
        });
        return isExistIndex === -1;
    });

    let recentItemsList = [...newRecentItems, ...savedRecentItems];
    if (recentItemsList.length > 20) {
        recentItemsList = recentItemsList.slice(0, 20);
    }
    return recentItemsList;
};

export const getCommandMenuLastUpdatedDataTime = (userId: number = 0) => {
    const data = getCommandMenuRecentItemsData(userId);
    return data.lastUpdated;
};

export const saveLoadedCommandMenuSavedItems = (
    userId: number = 0,
    recentItems: CommandMenuRecentItem[],
    time: string,
) => {
    const data = getCommandMenuRecentItemsData(userId);

    saveCommandMenuRecentItemsData(userId, { ...data, savedItems: recentItems, lastUpdated: time });
};
